'use client';

import { LayoutContainer, Section } from '@petsmart-ui/sparky';

import type { VisualNavigationProps } from './types';
import Tile6UpVisualNav from './Tile6UpVisualNav';

export function VisualNavigation({ variant, header, tiles, isH1 }: VisualNavigationProps) {
    return (
        <LayoutContainer className="visual-navigation-container">
            <Section
                data-testid="visual-navigation-test-id"
                title={header || ''}
                headingTagName={isH1 ? 'h1' : 'h2'}
                className="visual-navigation-section"
            >
                <Tile6UpVisualNav variant={variant} header={header} tiles={tiles} overrideDefaultClass />
            </Section>
        </LayoutContainer>
    );
}

export default VisualNavigation;
